<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import URL from '@/views/mis/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t("mis.bt.search") == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }
      },
      bthClick (clickName, row) {
          if (clickName == "detail"){
              //跳转到详情页
              this.$router.push({path:"/mis/kcharts/ktradelog",query:{phone:row.phone,month:row.month,label:"MIS"}});
          }
      },
    },
    data () {
      return {
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t("mis.common.startTime"), field: 'startTime',type:5},
              { title: window.$t("mis.common.endTime"), field: 'endTime',type:5},
              { title: window.$t("mis.common.phone"), field: 'phone'},
              { title: window.$t("mis.kscore.month"), field: 'month'},
              {click:window.$t("mis.bt.search")}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.kcharts.scoreList, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: window.$t("mis.common.phone"), field: 'phone'},
              { title: window.$t("mis.common.name"), field: 'name'},
              { title: window.$t("mis.kscore.profit"), field: 'profit'},
              { title: window.$t("mis.kscore.month"), field: 'month'},
              { title: window.$t("mis.common.createTime"), field: 'createTime',render:(data)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              {field: window.$t("mis.kscore.detail"),size:"mini",click:"detail",type:"primary",icon:"el-icon-query"}
          ]
        }
      }
    }
  }
</script>
